<template>
    <v-row v-if="$rc.inIndustry('wine')" class="my-1">
        <v-col cols="12">
            <v-alert
                type="error"
                class="shaded-light"
                border="left"
                colored-border
            >
                <div>
                    <slot name="title">
                        <strong>Urgent Emerging Carrier Issue:</strong> We recommend you temporarily refrain from sending bulk messages that promote wine sales. We're seeing unusual carrier blocking and will share updates as soon as we have more clarity.
                    </slot>
                </div>

                <div class="mt-4">
                    <winery-carrier-alert-content show="latest-update" />
                </div>

                <div class="mt-2">
                    <a
                        href="#"
                        @click.prevent="show_details = !show_details"
                    >
                        {{ show_details ? 'Read less' : 'Read more' }}
                        <v-icon color="primary" small>{{ show_details ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </a>
                </div>

                <v-expand-transition>
                    <div
                        v-show="show_details"
                        class="mt-4"
                    >
                        <winery-carrier-alert-content show="expanded-content" />
                    </div>
                </v-expand-transition>
            </v-alert>
        </v-col>
    </v-row>
</template>

<script>
import WineryCarrierAlertContent from '@/components/bulk/winery-carrier-alert-content.vue';

export default {
    name: 'TempDisableWineriesFromScheduling',

    components: {
        WineryCarrierAlertContent,
    },

    data() {
        return {
            show_details: false,
        };
    },
};
</script>

<style lang="scss" scoped>
a {
    color: var(--v-primary-base) !important;
    text-decoration: none;
}
</style>